<template>
	<div
		v-if="application"
		class="question-page"
		style="background-color: #ecf2f9"
	>
		<!--<header class="question-page-header">
            <div class="store-name">
                {{fimenu.storeInfo.storeName}}
            </div>
            <img class="store-logo" :src="fimenu.storeInfo.theme.logoSrc" @error="util.handleImageError(fimenu.storeInfo.theme)" />
            <div class="store-address">
                <div>
                    {{fimenu.storeInfo.storeAddress}}
                </div>
                <div>
                    {{fimenu.storeInfo.storeCity + ", " + fimenu.storeInfo.storeState + " " + fimenu.storeInfo.storeZip}}
                </div>
                <div>
                    {{fimenu.storeInfo.storePhone}}
                </div>
            </div>
        </header>-->
		<CreditAppQuestionnaire
			v-if="termsAccepted && application"
			:application="application"
			:customerAppBasic="fimenu"
			:terms="terms"
			:acceptedTermsDate="acceptedTermsDate"
			:acceptedTermsDateOffset="acceptedTermsDateOffset"
		/>
		<CreditAppLegal
			v-if="application && !termsAccepted"
			:customerAppBasic="fimenu"
			:acceptTerms="acceptTerms"
			:terms="terms"
		/>
	</div>
</template>

<script>
	import api from '@core/services/api/_api';
	import ApplicationsSettingsLoader from '@core/classes/Applications/ApplicationsSettingsLoader';
	import CreditAppLegal from '@/views/CreditAppLegal.vue';
	import CreditAppQuestionnaire from '@/views/CreditAppQuestionnaire.vue';
	import ENUMS from '@core/classes/Enums';
	import LOCALIZATION from '@core/classes/Localization';
	import LogRocket from 'logrocket';
	import moment from 'moment';
	import settings from 'settings';
	import util from '@core/services/util';

	export default {
		name: 'CreditAppMain',
		props: ['fimenu'],
		data() {
			return {
				terms: null,
				termsAccepted: false,
				termsData: null,
				application: null,
				pageInitialHeight: 0,
				language: 'English',
				lenderListText: null,
				acceptedTermsDate: null,
				acceptedTermsDateOffset: 0,
			};
		},
		async created() {
			await this.init();
			this.pageInitialHeight = window.innerHeight;
			window.addEventListener('resize', this.onResizeHandler);
			await this.getTerms();
			this.setupLogRocket();
		},
		computed: {
			localization() {
				return LOCALIZATION;
			},
			util() {
				return util;
			},
			ENUMS() {
				return ENUMS;
			},
			legalTermOptions() {
				return [
					ENUMS.LegalTermTypes.TERMS_AND_CONDITIONS,
					ENUMS.LegalTermTypes.ADVERSE_ACTION_NOTICE,
					ENUMS.LegalTermTypes.PRIVACY_NOTICE,
					ENUMS.LegalTermTypes.SMS_CONSENT,
				];
			},
			languageOptions() {
				return ENUMS.LANGUAGE_DISPLAY;
			},
		},
		methods: {
			setupLogRocket() {
				LogRocket.init(settings.logRocketOrg); // Keeping this here, in case the link is from out of store, we dont start recording til this page
				//LogRocket.init(settings.logRocketOrg, { rootHostname: settings.logRocketRootHostName }); // Keeping this here, in case the link is from out of store, we dont start recording til this page

				const formatedDob = moment(this.application?.preFilledData?.dateOfBirth, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]').format('MM/DD/YYYY');

				LogRocket.track('Customer_App_Session', {
					applicationID: this.application?.id,
					email: this.application?.preFilledData.emailAddress ?? '',
					phone: this.application?.preFilledData.phoneNumber ?? '',
					environment: settings.environmentName,
					storeName: this.fimenu?.storeInfo.storeName,
				});
				LogRocket.identify(
					`${this.application?.preFilledData.phoneNumber} - ${this.application?.preFilledData.emailAddress} - ${formatedDob} - Customer_App_Session`,
					{
						name: this.application?.id ?? '',
						email: this.application?.preFilledData.emailAddress ?? '',
						storeName: this.fimenu?.storeInfo.storeName ?? '',
						environment: settings?.environmentName ?? '',
					},
				);
			},
			async init() {
				//if sent here to edit, the query will have the id
				if (this.$route.query.id) {
					await this.loadAppFromLink();
				} else {
					await this.loadApp();
				}
			},
			async loadApp() {
				//You can't be in this component without store and language information, push to login
				const fimenuObject = localStorage.getItem('fimenuObject');
				if (!fimenuObject) {
					this.$router.push({
						name: 'creditappLogin',
						query: { errorCode: '0001' },
					});
					return;
				}
				this.populateFimenu(fimenuObject);

				//If does exist, use it to restore locally saved answers.
				let applicationObject = localStorage.getItem('applicationObject');
				if (applicationObject) {
					applicationObject = JSON.parse(util.decryptJSONText(applicationObject));
					const { data: appData } = await api.applications.getApplication(applicationObject.id);
					appData.quoteAppData = applicationObject.quoteAppData;
					appData.plaidId = applicationObject.plaidId;
					appData.dateCompleted = applicationObject.dateCompleted;
					appData.isSingleQuestionEdit = applicationObject.isSingleQuestionEdit;

					this.application = appData;
					//this.termsAccepted = true;
				} else {
					//You can't be in this component without this code, push to login
					const localStorageCode = localStorage.getItem('QuoteApplication');
					if (!localStorageCode) {
						this.$router.push({
							name: 'creditappLogin',
							query: { errorCode: '0002' },
						});
						return;
					}

					try {
						const response = await api.applications.getApplicationByEmailCode(this.$route.query.emailCode);
						if (response.data) {
							this.application = response.data;
						} else
							this.$router.push({
								name: 'creditappLogin',
								query: { errorCode: '0008' },
							});
					} catch (error) {
						this.$router.push({
							name: 'creditappLogin',
							query: { errorCode: '0003' },
						});
						console.error(error);
					}
				}
			},
			async loadAppFromLink() {
				const { data: appData } = await api.applications.getApplication(this.$route.query.id);
				if (!appData || moment().diff(moment(appData.editLinkExpiration, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]')) >= 0) {
					this.$router.push({
						name: 'creditappLogin',
						query: { errorCode: '0004' },
					});
					return;
				}

				if (appData) this.application = appData;

				//update path and current question
				let questionIndex = appData.quoteAppData.pathFollowed.indexOf(this.$route.query.questionKey);
				if (questionIndex == -1) {
					appData.quoteAppData.pathFollowed.push(this.$route.query.questionKey);
					questionIndex = appData.quoteAppData.pathFollowed.length - 1;
				}

				appData.quoteAppData.fullPathFollowed = appData.quoteAppData.pathFollowed;
				appData.quoteAppData.pathFollowed = appData.quoteAppData.pathFollowed.slice(0, questionIndex);
				appData.quoteAppData.currentQuestion = this.$route.query.questionKey;

				if (this.$route.query.isSingleQuestionEdit) {
					appData.isSingleQuestionEdit = true;
				}

				if (this.$route.query.resetDateCompleted) {
					appData.dateCompleted = null;
				}

				localStorage.setItem('applicationObject', util.encryptJSONText(JSON.stringify(appData)));

				if (!this.$route.query.storeCode)
					return this.$router.push({
						name: 'creditappLogin',
						query: { errorCode: '52525' },
					});
				const response = await api.settings.getStoreBasicInfo(this.$route.query.storeCode);
				if (!response.data) {
					this.$router.push({
						name: 'creditappLogin',
						query: { errorCode: '0006' },
					});
					return;
				}

				this.fimenu.language = appData.quoteAppData.language;
				if (response.data.theme.mainTextColor) {
					//response.data.theme.logoSrc = `https://localhost:44355/Settings/GetStoreLogoFile?storeCode=${this.$route.query.storeCode}`
				} else {
					response.data.theme = ApplicationsSettingsLoader.ApplicationSettings.theme;
				}

				this.fimenu.storeInfo = response.data;
				localStorage.setItem('fimenuObject', JSON.stringify(this.fimenu));
			},
			populateFimenu(obj) {
				obj = JSON.parse(obj);
				Object.keys(this.fimenu).forEach(fi => {
					this.fimenu[fi] = obj[fi];
				});
			},
			getEnumDisplayValue(data, options) {
				const valueToMatch = options.find(term => term.value === data);
				return valueToMatch.display;
			},
			async getTerms() {
				let listOfLenders = [];
				await api.settings.getLenderNames().then(response => {
					listOfLenders = response.data;
				});

				this.lenderListText = listOfLenders
					.filter(l => l != '-- NOT LISTED --')
					.join('; ')
					.toUpperCase();

				try {
					const response = await api.settings.getLegalTermsByType(true, this.legalTermOptions);
					if (response) this.termsData = response.data;
				} catch (error) {
					console.error('error', error);
				} finally {
					this.createTermsList();
				}
			},
			createTermsList() {
				const updatedTerms = this.termsData?.map(term => {
					const languageMatch = term.nameTranslations.find(nt => this.getEnumDisplayValue(nt.language, this.languageOptions) === this.fimenu.language);
					return {
						id: term.id,
						dateCreated: term.dateCreated,
						termsType: term.termsType,
						termsText: term.termsType === 0 ? languageMatch.termsText + this.lenderListText : languageMatch.termsText,
						language: this.getEnumDisplayValue(languageMatch.language, this.languageOptions),
						termsLabel: languageMatch.termsLabel,
						isChecked: false,
					};
				});

				//Get Adverse Actions Notice and insert Store Name and Store Location into termsText
				if (updatedTerms) {
					const nameRegex = new RegExp('DEALERSHIP_NAME', 'g');
					const addressRegex = new RegExp('DEALERSHIP_ADDRESS', 'g');
					const phoneRegex = new RegExp('DEALERSHIP_PHONE', 'g');

					const adverseActionNotice = updatedTerms.find(term => term.termsType === ENUMS.LegalTermTypes.ADVERSE_ACTION_NOTICE);
					adverseActionNotice.termsText = adverseActionNotice.termsText.replace(nameRegex, this.fimenu.storeInfo.storeName);
					adverseActionNotice.termsText = adverseActionNotice.termsText.replace(
						addressRegex,
						this.fimenu.storeInfo.storeAddress +
							'<br>' +
							this.fimenu.storeInfo.storeCity +
							', ' +
							this.fimenu.storeInfo.storeState +
							' ' +
							this.fimenu.storeInfo.storeZip,
					);
					adverseActionNotice.termsText = adverseActionNotice.termsText.replace(phoneRegex, util.formatPhoneNumber(this.fimenu.storeInfo.storePhone));

					this.terms = updatedTerms;
				}
			},
			acceptTerms() {
				this.termsAccepted = true;

				this.acceptedTermsDate = util.toMomentUtc(new Date());
				this.acceptedTermsDateOffset = util.toMoment(new Date()).utcOffset();

				const acceptedTerms = this.terms.map(t => ({
					id: t.id,
					termsType: t.termsType,
					termsLabel: t.termsLabel,
					termsText: t.termsText,
				}));

				api.applications.updateApplication({
					application: this.application,
					acceptedTerms,
					userDateTime: this.acceptedTermsDate,
					userDateTimeOffset: this.acceptedTermsDateOffset,
				});
			},
			onResizeHandler() {
				const metaViewport = document.querySelector('meta[name=viewport]');
				if (window.innerHeight < this.pageInitialHeight) {
					// document.documentElement.style.setProperty('overflow', 'auto')
					metaViewport.setAttribute('content', 'height=' + this.pageInitialHeight + ',width=device-width,initial-scale=1.0');
				} else {
					metaViewport.setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0');
				}
			},
		},
		components: {
			CreditAppQuestionnaire,
			CreditAppLegal,
		},
	};
</script>
<style>
	.question-page-header > * {
		opacity: 0;
	}
</style>
